module.exports = __webpack_public_path__ + "img/address-details.9debd029.svg";